import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  dir: "ltr",
  t: translations.en,
  setLang: () => {},
  toggle: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("pis_lang") || "en";
  });

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.body.setAttribute("dir", dir);
    window.localStorage.setItem("pis_lang", lang);
  }, [lang]);

  const toggle = useCallback(() => {
    setLang((prev) => (prev === "en" ? "ar" : "en"));
  }, []);

  const value = useMemo(
    () => ({
      lang,
      dir: lang === "ar" ? "rtl" : "ltr",
      t: translations[lang] || translations.en,
      setLang,
      toggle,
    }),
    [lang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
